import { render, staticRenderFns } from "./laporan_mutasi.vue?vue&type=template&id=4a20b7e4&"
import script from "./laporan_mutasi.vue?vue&type=script&lang=js&"
export * from "./laporan_mutasi.vue?vue&type=script&lang=js&"
import style0 from "./laporan_mutasi.vue?vue&type=style&index=0&id=4a20b7e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports